import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache) {
  return _openBlock(), _createBlock("h1", null, "I've been doing some async work before nicely rendering");
}